// extracted by mini-css-extract-plugin
export default {"MouseMove":"mousemove_MouseMove__GZ0KS","large_circle":"mousemove_large_circle__rifT4"};